import { useMyAccess } from 'features/users';
import useListParams from 'hooks/useListParams';

const useAccessModify = () => {
  const { project, tab } = useListParams();
  const myAccess = useMyAccess(project ? { id: parseInt(project) } : undefined);

  const accessRules = {
    pause: myAccess?.rules.includes('rule_start-stop') && tab !== 'paused',
    unpause: myAccess?.rules.includes('rule_start-stop') && tab === 'paused',
    duplicate: myAccess?.rules.includes('create'),
    edit: myAccess?.rules.includes('update'),
    archive: myAccess?.rules.includes('rule_archive') && tab !== 'archived',
    unarchive: myAccess?.rules.includes('rule_archive') && tab === 'archived',
    manually: myAccess?.rules.includes('rule_run') && tab !== 'archived' && tab !== 'paused',
    bulk: myAccess?.rules.includes('rule_bulk-actions'),
    addToFlow: myAccess?.rules.includes('rule_add-to-flow'),
  };

  return {
    myAccess,
    accessRules,
  };
};

export default useAccessModify;
